import { Dayjs } from 'dayjs';

export interface MovFormaPagamento {
    codigo: number|EnumMovFormaPagamento;
    nome: string;
    ativo: boolean;
    dataCriacao: Date | Dayjs;
}
export enum EnumMovFormaPagamento {
    Deposito = 1,
    TransferenciaBancaria,
    Dinheiro,
    Boleto,
    Debito,
    Credito,
    Pix,
    Cheque,
    Outros
}